<template>
	<v-container>
		<v-app id="inspire" class="mb-12">
			<v-row class="mb-10">
				<v-col class="mb-12">
					<div
						class="pa-4"
						style="border-bottom: 1px solid black; border-top: 1px solid black;"
					>
						<h1 style="text-align:center;" class="text-uppercase">Calendar</h1>
					</div>
					<v-sheet height="64">
						<v-toolbar flat class="d-flex justify-space-around white">
							<v-btn fab text small color="grey darken-2" @click="prev">
								<v-icon large>
									mdi-chevron-left
								</v-icon>
							</v-btn>
							<v-toolbar-title v-if="$refs.calendar" class="px-10">
								{{ $refs.calendar.title }}
							</v-toolbar-title>
							<v-btn fab text small color="grey darken-2" @click="next">
								<v-icon large>
									mdi-chevron-right
								</v-icon>
							</v-btn>
						</v-toolbar>
					</v-sheet>
					<v-sheet height="100%">
						<v-calendar
							ref="calendar"
							v-model="focus"
							color="primary"
							:events="events"
							:event-color="getEventColor"
							:type="type"
							@click:event="showEvent"
							@click:date="viewDay"
							@change="updateRange"
						></v-calendar>
						<v-menu
							v-model="selectedOpen"
							:close-on-content-click="false"
							:activator="selectedElement"
							offset-x
							max-width="400"
						>
							<v-card
								color="grey lighten-4"
								min-width="250"
								max-height="400"
								flat
								style="overflow: scroll;"
							>
								<v-toolbar :color="selectedEvent.color" dark>
									<v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn text color="white" route :to="selectedEvent.catagory">
										<v-icon small>
											near_me
										</v-icon>
									</v-btn>
								</v-toolbar>
								<v-card-text>
									<span><b>Time: </b> {{ selectedEvent.time }}</span>
									<br />
									<span v-html="selectedEvent.details"></span>
								</v-card-text>
							</v-card>
						</v-menu>
					</v-sheet>
				</v-col>
			</v-row>
		</v-app>
	</v-container>
</template>

<script>
import fb from "@/fb";
export default {
	data: () => ({
		focus: "",
		type: "month",
		typeToLabel: {
			month: "Month",
			week: "Week",
			day: "Day",
			"4day": "4 Days",
		},
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		events: [],
		colors: [
			"blue",
			"indigo",
			"deep-purple",
			"cyan",
			"green",
			"orange darken-2",
			"grey darken-1",
			"pink",
			"yellow darken-2",
		],
	}),
	mounted() {
		this.$refs.calendar.checkChange();
	},
	methods: {
		viewDay({ date }) {
			if (this.type == "month") {
				this.focus = date;
				this.type = "day";
			} else {
				this.type = "month";
			}
		},
		getEventColor(event) {
			return event.color;
		},
		setToday() {
			this.focus = "";
		},
		prev() {
			this.$refs.calendar.prev();
		},
		next() {
			this.$refs.calendar.next();
		},
		showEvent({ nativeEvent, event }) {
			const open = () => {
				this.selectedEvent = event;
				this.selectedElement = nativeEvent.target;
				setTimeout(() => {
					this.selectedOpen = true;
				}, 10);
			};

			if (this.selectedOpen) {
				this.selectedOpen = false;
				setTimeout(open, 10);
			} else {
				open();
			}

			nativeEvent.stopPropagation();
		},
		timeFormatted: function(time) {
			var timeFormatted;
			var timeCheck = time.slice(0, 2);
			if (timeCheck <= 12) {
				if (timeCheck >= 10) {
					timeFormatted = time.slice(0, 5) + " AM";
				} else {
					timeFormatted = time.slice(1, 5) + " AM";
				}
			} else {
				timeFormatted = timeCheck - 12 + time.slice(2, 5) + " PM";
			}
			return timeFormatted;
		},
		async updateRange() {
			const events = [];
			const upcomingEvents = await fb.db.collection("Events").get();
			const specialtyTrips = await fb.db.collection("SpecialtyTrips").get();

			upcomingEvents.docs.forEach((doc) => {
				if (doc.data().date) {
					const {
						date,
						location,
						description,
						title,
						timeSlots,
						time,
						endDate,
						timestamp,
					} = doc.data();

					const isKidsCamp = location.id === "kids-camps";
					const route = isKidsCamp
						? location.route
						: `${location.route}/${location.id}`;

					//const today = new Date();
					//const offset = today.getTimezoneOffset() * 60000;
					const eventDate = new Date(timestamp);

					events.push({
						name: title ? title : "",
						start: eventDate,
						end: isKidsCamp ? endDate : date,
						color: isKidsCamp ? this.colors[4] : this.colors[5],
						catagory: route,
						details: description,
						time: isKidsCamp
							? this.timeFormatted(time)
							: this.timeFormatted(timeSlots[0]),
					});
				}
			});

			specialtyTrips.docs.forEach((doc) => {
				if (doc.data().date) {
					events.push({
						name: doc.data().type,
						start: doc.data().date,
						end: doc.data().date,
						color: this.colors[8],
						catagory: doc.data().trip,
						details: "",
						time: "TBD",
					});
				}
			});
			this.events = events;
		},
	},
};
</script>
